import { render, staticRenderFns } from "./PPEListComponent.vue?vue&type=template&id=3f7ac71e&"
import script from "./PPEListComponent.vue?vue&type=script&lang=js&"
export * from "./PPEListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports